(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6544],{

/***/ 66117:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explore",
      function () {
        return __webpack_require__(62989);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 61911:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/default-header-mobile-bg-support.cd0bade6.png","height":282,"width":423,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAXVBMVEXWhJD/tYjBqbHestChZFJ9Zm//3sPMoY7//7r64MiUaGPXvsiIfG/Oin2usKSwu+72wrm8sdOAdmuupbqxv/DSp5mAXlGifpmul8LGvr7TubnDlICbe6mch3jXn3n06uIzAAAAG3RSTlMBRdBXodRfcQs16ocposdLj93efmmhZ4WyO/VV7xZrAAAACXBIWXMAAAsTAAALEwEAmpwYAAAANUlEQVR4nGNg4BcWkRTjYWBgEJUT5JMV4mBgYGfnZWGRZmPglJKREGDlYmTgYBfn5GZiZgAAMKUB9YTlSAAAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 40570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37946);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none;\n  background: none;\n  display: inline-block;\n  text-decoration: none;\n  text-align: center;\n  background: ",
        "!important;\n  padding: 1.5rem;\n  color: ",
        "!important;\n  text-transform: uppercase;\n  font-size: 1.2rem;\n  font-weight: bold;\n  border-radius: 4px!important;\n  transition: transform 0.3s;\n  backface-visibility: hidden;\n  will-change: transform;\n  cursor: pointer;\n  border: ",
        "!important;\n  opacity: ",
        ";\n  span {\n    margin-left: 1.5rem;\n  }\n\n  &:hover {\n    transform: scale(1.025);\n  }\n\n  :disabled {\n    background-color: #bbb;\n    color: #fff;\n    border: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Button = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-775d42b7-0"
})(_templateObject(), function(props) {
    return props.transparent ? "transparent" : "#174F68";
}, function(props) {
    return props.transparent ? "#174F68" : "#fff";
}, function(props) {
    return props.transparent ? "solid 1px #174F68" : "none";
}, function(props) {
    return props.isLoading ? "0.5" : "1";
});
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 56505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89583);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37946);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n\n  & button {\n    border: none;\n    height: 39px !important;\n    width: 39px !important;\n    padding: 0.5rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 10px;\n    cursor: pointer;\n    background-color: #ffffff;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    transition: all 0.2s;\n    font-size: 14px;\n    color: #174f68;\n\n    :active {\n      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);\n    }\n    :disabled {\n      background-color: #f5f5f5;\n      color: #cccccc;\n      :active {\n        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var generateButtonStyle = function(isActive) {
    return {
        backgroundColor: isActive ? "#174f68" : undefined,
        color: isActive ? "#ffffff" : undefined,
        fontWeight: isActive ? "bold" : undefined,
        border: isActive ? "solid 1px white" : "solid 1px transparent"
    };
};
var Pagination = function(param) {
    var currentPage = param.currentPage, onPress = param.onPress, totalPages = param.totalPages, onNextPage = param.onNextPage, onPreviewPage = param.onPreviewPage;
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var buttons = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return Array.from({
            length: totalPages
        }, function(_, index) {
            var pageNumber = index + 1;
            var isActive = index + 1 === currentPage;
            // Special case for button 2 - make it work like the next button
            var handleClick = function(e) {
                e.currentTarget.focus();
                // If it's button 2, use the next functionality instead
                if (pageNumber === 2) {
                    console.log("Button 2 clicked - using next functionality");
                    onNextPage();
                } else {
                    onPress(pageNumber);
                }
            };
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, generateButtonStyle(isActive)), {
                    width: 47,
                    height: 47
                }),
                ref: isActive ? containerRef : undefined,
                onClick: handleClick,
                children: pageNumber
            }, index);
        });
    }, [
        currentPage,
        onPress,
        totalPages,
        onNextPage
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Container, {
        children: totalPages > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                    disabled: currentPage === 1,
                    onClick: onPreviewPage,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_5__/* .FaArrowLeft */ .x_l, {
                        size: 15
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    style: {
                        width: 150,
                        display: "flex",
                        flexDirection: "row",
                        overflow: "hidden"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "row",
                            gap: 15,
                            marginBottom: 10
                        },
                        children: buttons
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                    disabled: currentPage === totalPages,
                    onClick: onNextPage,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_5__/* .FaArrowRight */ .Z1Y, {
                        size: 15
                    })
                })
            ]
        })
    });
};
var Container = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a8fc0af0-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (Pagination);


/***/ }),

/***/ 62989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PaginationContainer": function() { return /* binding */ PaginationContainer; },
/* harmony export */   "default": function() { return /* binding */ PoolView; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(37946);
/* harmony import */ var components_Page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97059);
/* harmony import */ var components_Pagination__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56505);
/* harmony import */ var components_PoolCard__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91638);
/* harmony import */ var contexts_Loader__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41068);
/* harmony import */ var services_apiClient__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81372);
/* harmony import */ var utils_media__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(13274);
/* harmony import */ var components_FilterPoolCard__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7802);





function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  min-height: calc(98vh - (400px));\n\n  .swiper-slide {\n    width: auto !important;\n    margin: 0 2rem;\n    margin-bottom: 10rem;\n  }\n\n  & > section {\n    & h1 {\n      font-family: 'P22 Mackinac Pro';\n      font-size: 3.5em;\n      color: #174F68;\n      font-weight: 500;\n      line-height: 58px;\n      letter-spacing: 0em;\n    }\n\n    @media (max-width: 768px) {\n      h1 {\n        padding: 25px;\n        font-size: 2.8em;\n      }\n    }\n    \n    & p {\n      font-family: 'Nunito';\n      font-size: 1.5em;\n      font-weight: 400;\n      line-height: 27px;\n      letter-spacing: 0em;\n    }\n    .activeSlider {\n      opacity: 1;\n      width: 25px;\n      border-radius: 100px;\n      background-color: #ffffff !important;\n    }\n    &:first-child {\n      position: relative;\n      max-width: 130em;\n      width: 100%;\n      margin: 0 auto;\n\n      display: flex;\n      flex-direction: row;\n      min-height: calc(863px - 114px);\n      margin-top: 60px;\n\n      margin-bottom: -150px;\n\n      & > div {\n        display: flex;\n        flex: 1;\n\n\n        & h1 {\n          margin-top: 40px;\n          text-align: left;\n          max-width: 600px;\n        }\n\n        &:first-child {\n          display: flex;\n          flex-direction: column;\n          color: #174f68;\n\n          & p {\n            text-align: left;\n            max-width: 591px;\n            margin: 13px 0;\n          }\n        }\n\n        &:last-child {\n          display: flex;\n          justify-content: flex-end;\n        }\n      }\n    }\n    &:nth-child(2) {\n      position: relative;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      position: relative;\n    }\n    &:nth-child(3) {\n      background-color: #FBF9ED;\n      & > div {\n        position: relative;\n        //max-width: 130em;\n        width: 100%;\n        margin: 0 auto;\n        padding: 63px /*4rem*/ 0;\n        color: #222222;\n        display: flex;\n        flex-direction: column;\n\n        & h1 {\n          text-align: center;\n          max-width: 615px;\n        }\n        \n\n        & > div {\n          &:first-child,\n          &:nth-child(2) {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n          }\n          &:nth-child(3) {\n            margin: 64px 0;\n            align-self: center;\n            min-width: 130em;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n          }\n        }\n      }\n    }\n  }\n\n  ",
        " {\n    & > section {\n      &:first-child {\n        margin-top: 6rem !important;\n        flex-direction: column;\n\n        & button {\n          width: auto !important;\n          margin-bottom: 1rem !important;\n        }\n\n        & > div {\n          &:first-child {\n            & > div:nth-child(2) {\n              margin-top: -3rem;\n              h1 {\n                font-size: 2.7rem;\n                line-height: 35px;\n              }\n            }\n          }\n        }\n      }\n      &:nth-child(3) {\n        & h1 {\n          font-size: 2.7rem;\n          line-height: 35px;\n        }\n      }\n    }\n  }\n\n  ",
        " {\n    & > section {\n      &:first-child {\n        flex-direction: column;\n\n        & button {\n          width: auto !important;\n          margin-bottom: 1rem !important;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 4rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-self: center;\n  align-items: center;\n  justify-content: center;\n  margin-top: 64px;\n  gap: 30px;\n  max-width: 130em;\n  margin: 34px auto;\n\n  a,\n  a:visited,\n  a:active {\n    text-decoration: none !important;\n  }\n\n  ",
        " {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  ",
        " {\n    grid-template-columns: 1fr;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}











function PoolView(param) {
    var categories = param.categories, states = param.states, periods = param.periods;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]), pools = ref[0], setPools = ref[1];
    var setLoader = (0,contexts_Loader__WEBPACK_IMPORTED_MODULE_7__/* .useLoader */ .U)().setLoader;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(), filter = ref1[0], setFilter = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0), totalPools = ref2[0], setTotalPools = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0), totalPoolPages = ref3[0], setTotalPoolPages = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(1), currentPage = ref4[0], setCurrentPage = ref4[1];
    var getPoolsWithFilter = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(page) {
            var ref, data, ref1, mappedPools, _total;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoader === null || setLoader === void 0 ? void 0 : setLoader(true);
                        return [
                            4,
                            services_apiClient__WEBPACK_IMPORTED_MODULE_8__/* .api.post */ .h.post("/pools/_search/?limit=9&page=".concat(page), filter ? {
                                category_id: filter.categoryId,
                                state: filter.state,
                                period: filter.period
                            } : undefined)
                        ];
                    case 1:
                        data = _state.sent().data;
                        mappedPools = (ref1 = (ref = data.values) === null || ref === void 0 ? void 0 : ref.map(function(pool) {
                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, pool), {
                                active: pool.status !== "finished"
                            });
                        })) !== null && ref1 !== void 0 ? ref1 : [];
                        setPools(mappedPools);
                        setTotalPools((_total = data.total) !== null && _total !== void 0 ? _total : 0);
                        setCurrentPage(page);
                        setTotalPoolPages(data.pages);
                        setLoader === null || setLoader === void 0 ? void 0 : setLoader(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function(page) {
            return _ref.apply(this, arguments);
        };
    }(), [
        setLoader,
        filter
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        getPoolsWithFilter(currentPage);
    }, [
        currentPage,
        getPoolsWithFilter
    ]);
    var getPools = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(page) {
            var ref, data, ref1, mappedPools, _total;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoader === null || setLoader === void 0 ? void 0 : setLoader(true);
                        return [
                            4,
                            services_apiClient__WEBPACK_IMPORTED_MODULE_8__/* .api.get */ .h.get("/pools/all/?limit=9&page=".concat(page))
                        ];
                    case 1:
                        data = _state.sent().data;
                        mappedPools = (ref1 = (ref = data.values) === null || ref === void 0 ? void 0 : ref.map(function(pool) {
                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, pool), {
                                active: pool.status !== "finished"
                            });
                        })) !== null && ref1 !== void 0 ? ref1 : [];
                        setPools(mappedPools);
                        setTotalPools((_total = data.total) !== null && _total !== void 0 ? _total : 0);
                        setCurrentPage(page);
                        setTotalPoolPages(data.pages);
                        setLoader === null || setLoader === void 0 ? void 0 : setLoader(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function(page) {
            return _ref.apply(this, arguments);
        };
    }(), [
        setLoader
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        getPools(currentPage);
    }, [
        currentPage,
        getPools
    ]);
    var handleNextPage = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        var next = currentPage + 1;
        if (totalPools >= next) getPools(next);
    }, [
        currentPage,
        getPools,
        totalPools
    ]);
    var handlePreviewPage = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        var preview = currentPage - 1;
        if (totalPools > preview) getPools(preview);
    }, [
        currentPage,
        getPools,
        totalPools
    ]);
    var handleOnFilter = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(filter) {
        setFilter(filter);
        getPoolsWithFilter(1);
    }, [
        getPoolsWithFilter
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Page__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        isPublicPage: true,
        navbar: true,
        title: "Vaquinha",
        description: "Explore as vaquinhas.",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SearchCategories, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_FilterPoolCard__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        onSearch: handleOnFilter
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                                    children: "Fa\xe7a a diferen\xe7a na vida de outras fam\xedlias"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PoolGrid, {
                                children: pools.map(function(item, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            href: "/".concat(item.slug),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                href: "/".concat(item.slug),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_PoolCard__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                    data: item
                                                })
                                            })
                                        })
                                    }, index);
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PaginationContainer, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Pagination__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    onPress: getPools,
                                    currentPage: currentPage,
                                    totalPages: totalPoolPages,
                                    onNextPage: handleNextPage,
                                    onPreviewPage: handlePreviewPage
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}
var Container = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7a13073-0"
})(_templateObject(), (0,utils_media__WEBPACK_IMPORTED_MODULE_9__/* .media */ .B)("<=tablet"), (0,utils_media__WEBPACK_IMPORTED_MODULE_9__/* .media */ .B)("<=phone"));
var SearchCategories = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7a13073-1"
})(_templateObject1());
var PaginationContainer = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7a13073-2"
})(_templateObject2());
var PoolGrid = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-7a13073-3"
})(_templateObject3(), (0,utils_media__WEBPACK_IMPORTED_MODULE_9__/* .media */ .B)("<=tablet"), (0,utils_media__WEBPACK_IMPORTED_MODULE_9__/* .media */ .B)("<=phone"));


/***/ }),

/***/ 43620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ fontAdjusts; }
/* harmony export */ });
/* unused harmony export buildName */
/**
 * This method create a friendly string name
 * @param names fullname string
 * @param separator separator  ``|`` default
 * @returns
 */ var buildName = function(names, joinWith) {
    var separator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "|";
    if (!names) return "";
    var arrNames = names.split(separator).filter(function(item) {
        return item !== "";
    });
    var name = arrNames.join(", ");
    return name.substring(0, name.lastIndexOf(",")) + (arrNames.length > 1 ? joinWith ? joinWith : " e " : "") + name.substring(name.lastIndexOf(","), name.length).replace(", ", "");
};
var fontAdjusts = function(texto) {
    var tamanhoFonteBase = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 14;
    var tamanhoTexto = texto.length;
    var fatorAjuste = 0.5; // Ajuste esse valor conforme necessário
    var tamanhoFonteCalculado = tamanhoFonteBase - tamanhoTexto * fatorAjuste;
    // Aplicar limite mínimo para o tamanho da fonte (por exemplo, 10 pixels)
    return Math.max(tamanhoFonteCalculado, 10);
};


/***/ }),

/***/ 40520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ isPoolVerified; }
/* harmony export */ });
var isPoolVerified = function(pool) {
    if (!pool) return false;
    return pool.verified === true || pool.isVerified === true;
};


/***/ }),

/***/ 73469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ index; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var index = react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect ;




/***/ }),

/***/ 63366:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,9866,1228,8907,4702,6804,2364,7059,5690,9774,2888,179], function() { return __webpack_exec__(66117); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);